import { Box, Image, Text } from "@chakra-ui/react"; //Vishy 2025-02-18 build warning "List, OrderedList not used, so removed
import React from "react";
import { Icons } from "../../Assets/icons";

type Props = {
  handleCloseModal: () => void;
};

const FAQModal = (props: Props) => {
  return (
    <Box>
      <Box
        position={"relative"}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        h={"60px"}
        w={"100%"}
      >
        <Text
          fontSize={"20px"}
          fontWeight={700}
          textAlign={"center"}
          color={"black"}
        >
          FAQ
        </Text>
        <Image
          onClick={() => {
            props.handleCloseModal();
          }}
          position={"absolute"}
          src={Icons.cross}
          right={0}
          top={0}
        />
      </Box>
      {/* Claude: scrollable FAQ content 25-03-2026 */}
      <Box maxH="60vh" overflowY="auto">
        <Box>
          <Text fontSize={"20px"} fontWeight={"semibold"}>
            What is Rewards program?
          </Text>
          <Text fontSize={"14px"} mt={2}>
            Rewards program is a loyalty program that rewards you for shopping
            with us. You can earn points on every purchase and redeem them for
            exciting gifts and offers.
          </Text>
        </Box>
        <Box>
          <Text fontSize={"20px"} fontWeight={"semibold"} mt={5}>
            What is Rewards program?
          </Text>
          <Text fontSize={"14px"} mt={2}>
            Rewards program is a loyalty program that rewards you for shopping
            with us. You can earn points on every purchase and redeem them for
            exciting gifts and offers.
          </Text>
        </Box>
        <Box>
          <Text fontSize={"20px"} fontWeight={"semibold"} mt={5}>
            What is Rewards program?
          </Text>
          <Text fontSize={"14px"} mt={2}>
            Rewards program is a loyalty program that rewards you for shopping
            with us. You can earn points on every purchase and redeem them for
            exciting gifts and offers.
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default FAQModal;
